export enum FusionEvents {
  APPLICATION_READY = 'gameLoad',
  SOUND_OFF = 'soundOff',
  SOUND_ON = 'soundOn',
  SOUND_CHANGED = 'muteHasChanged',
  TOGGLE_PAYTABLE = 'showPaytable',
  TOGGLE_HELP = 'showHelp',
  STOP_AUTOPLAY = 'stopAutoplay',
  RELOAD_BALANCE = 'updateBalance',
  SPIN_IN_PROGRESS = 'beforeRoundStart',
  SPIN_IN_PROGRESS_ENDED = 'roundEnd',
  GAME_RESUMED = 'gameResumed',
  GAME_ERROR = 'gameError',
  GAME_ERROR_EVENT = 'gameErrorEvent',
  TICKET_RECEIVED = 'ticketRecieved', // Typo in Fusion Codebase
  CLOSE = 'quit',
}

export type FusionPayload =
  | {
      data: boolean | string | number | null;
    }
  | FusionErrorPayload
  | undefined;

export type FusionErrorPayload = {
  data: {
    Status: {
      ErrCode?: number;
      ErrType?: number;
      UniqueErrorCode?: number;
      ErrMessage?: string;
    };
  };
};

export type FusionInitArgs = {
  region: string;
  gameCode?: string;
  onSuccess?: () => void;
  onError?: (err: unknown) => void;
};
